module.exports = __webpack_public_path__ + "img/visa3.356a540d.png";